var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiLogsNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-API_Logs_Normal"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "API_Logs_Normal",
    "data-name": "API Logs_Normal",
    clipPath: "url(#clip-API_Logs_Normal)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "API_Logs",
    "data-name": "API Logs",
    transform: "translate(1 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2071",
    "data-name": "Group 2071",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4561",
    "data-name": "Path 4561",
    d: "M32.39,9.76H9.49c-1.406,0-2.55.356-2.55.793V15.76c.033-.031,1.143,0,2.55,0H34.94V10.553C34.94,10.116,33.8,9.76,32.39,9.76Z",
    transform: "translate(-5.94 -8.834)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4562",
    "data-name": "Path 4562",
    d: "M33.267,31.34H9.793A3.343,3.343,0,0,1,6.53,27.932V12.748A3.343,3.343,0,0,1,9.793,9.34H18.3a.662.662,0,0,1,0,1.323H9.793a2.026,2.026,0,0,0-1.98,2.068V27.916a2.026,2.026,0,0,0,1.98,2.068H33.267a2.026,2.026,0,0,0,1.98-2.068V12.731a2.026,2.026,0,0,0-1.98-2.068H23.858a.662.662,0,0,1,0-1.323h9.409a3.343,3.343,0,0,1,3.263,3.408V27.932A3.343,3.343,0,0,1,33.267,31.34Z",
    transform: "translate(-6.53 -9.34)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4563",
    "data-name": "Path 4563",
    d: "M17.133,11.125H15.942a.882.882,0,1,1,0-1.765h1.191a.882.882,0,1,1,0,1.765Z",
    transform: "translate(-1.953 -9.316)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_837",
    "data-name": "Rectangle 837",
    d: "M0,0H28a0,0,0,0,1,0,0V4a2,2,0,0,1-2,2H2A2,2,0,0,1,0,4V0A0,0,0,0,1,0,0Z",
    transform: "translate(1 15)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_838",
    "data-name": "Rectangle 838",
    width: 28,
    height: 10,
    transform: "translate(1 6)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Text",
    transform: "translate(3 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4565",
    "data-name": "Path 4565",
    d: "M12.946,19.29h1.765v1.237H11.38V14.77h1.566v4.543Z",
    transform: "translate(-11.38 -14.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4566",
    "data-name": "Path 4566",
    d: "M14.526,20.262a2.834,2.834,0,0,1-1.059-1.056,3.14,3.14,0,0,1,0-3.057,2.834,2.834,0,0,1,1.059-1.056,2.964,2.964,0,0,1,2.912,0,2.63,2.63,0,0,1,1.037,1.056,3.3,3.3,0,0,1,0,3.057,2.834,2.834,0,0,1-1.059,1.056,2.964,2.964,0,0,1-2.912,0Zm2.4-1.506a1.547,1.547,0,0,0,.353-1.079A1.547,1.547,0,0,0,16.93,16.6a1.205,1.205,0,0,0-.948-.4,1.175,1.175,0,0,0-.948.4,1.66,1.66,0,0,0-.353,1.079,1.547,1.547,0,0,0,.353,1.079,1.314,1.314,0,0,0,1.9,0Z",
    transform: "translate(-8.467 -14.71)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4567",
    "data-name": "Path 4567",
    d: "M19.734,16.721a.97.97,0,0,0-.375-.36,1.106,1.106,0,0,0-.551-.112,1.184,1.184,0,0,0-.926.382,1.589,1.589,0,0,0-.331,1.057,1.561,1.561,0,0,0,.375,1.124,1.34,1.34,0,0,0,1.059.382,1.175,1.175,0,0,0,1.169-.764H18.565V17.283H21.5v1.551a2.966,2.966,0,0,1-.551.854,2.487,2.487,0,0,1-.9.652,2.7,2.7,0,0,1-1.235.247,2.981,2.981,0,0,1-1.5-.382,2.522,2.522,0,0,1-1.015-1.034,3.122,3.122,0,0,1-.353-1.529,2.976,2.976,0,0,1,.353-1.506A2.522,2.522,0,0,1,17.308,15.1a2.981,2.981,0,0,1,1.5-.382,2.941,2.941,0,0,1,1.765.517,2.26,2.26,0,0,1,.86,1.439h-1.7Z",
    transform: "translate(-3.555 -14.698)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4568",
    "data-name": "Path 4568",
    d: "M19.384,20.146a1.763,1.763,0,0,1-.684-1.371h1.676a.563.563,0,0,0,.176.45.608.608,0,0,0,.4.135.554.554,0,0,0,.353-.112.38.38,0,0,0,.132-.315.416.416,0,0,0-.243-.382,3.82,3.82,0,0,0-.75-.315c-.375-.135-.662-.247-.9-.36a1.841,1.841,0,0,1-.6-.517,1.371,1.371,0,0,1-.243-.877,1.634,1.634,0,0,1,.265-.944,1.684,1.684,0,0,1,.75-.607,2.81,2.81,0,0,1,1.081-.2,2.379,2.379,0,0,1,1.566.472A1.777,1.777,0,0,1,23,16.528H21.3a.473.473,0,0,0-.154-.382.513.513,0,0,0-.375-.135.415.415,0,0,0-.287.112.432.432,0,0,0-.11.292.4.4,0,0,0,.132.292.747.747,0,0,0,.309.2,5.573,5.573,0,0,0,.551.225,5.816,5.816,0,0,1,.882.382,1.479,1.479,0,0,1,.6.517,1.421,1.421,0,0,1,.243.832,1.848,1.848,0,0,1-.243.921,1.882,1.882,0,0,1-.728.652,2.454,2.454,0,0,1-1.125.247,2.6,2.6,0,0,1-1.61-.472Z",
    transform: "translate(0.911 -14.686)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiLogsNormal);
export default __webpack_public_path__ + "static/media/API_Logs_Normal.4cf81202cc8ee07582e394a834caa676.svg";
export { ForwardRef as ReactComponent };